import React from 'react';
import { useParams } from 'react-router-dom';
import ScenariosOverview from 'views/bluviu-nutrition/features/scenarios-v2/components/scenarios-overview';
import { BluViuNutritionProvider } from '../context/bluviu-nutrition-context';
import CalibrationsOverviewContainer from '../features/calibrations/components/calibrations-overview';
import ScenariosOverviewContainer from '../features/scenarios/components/scenarios-overview';
import { BluViuNutritionParams, BluViuNutritionTab } from '../types/bluviu-nutrition-params.type';

const BluViuNutrition = () => {
  const params = useParams<BluViuNutritionParams>();

  switch (params.tab) {
    case BluViuNutritionTab.SCENARIOS:
      return <ScenariosOverviewContainer />;
    case BluViuNutritionTab.CALIBRATIONS:
      return <CalibrationsOverviewContainer />;
    case BluViuNutritionTab.MULTICAGESCENARIO:
      return <ScenariosOverview />; /* Scenarios R2 */
  }
};

const BluViuNutritionContainer: React.FC = () => {
  return (
    <BluViuNutritionProvider>
      <BluViuNutrition />
    </BluViuNutritionProvider>
  );
};

export default React.memo(BluViuNutritionContainer);
